const interfacePhrases = {
    rate_limited: 'Frequenza limitata',
    limit_exceeded: 'Limite superato',
    used: 'Utilizzo',
    identifier: 'Identificatore',
    verification: 'Verifica',
    messages: 'Messaggi',
    data: 'Dati',
    custom: 'Personalizzato',
    management_api: 'API di gestione {{product}}',
    management_api_role_description: 'Questo ruolo integrato concede l’accesso all’API di gestione.',
    client_credentials: 'Credenziali client',
    authentication_request: 'Richiesta di autenticazione',
    callback: 'Ritorno di autenticazione',
    help_title: 'Centro assistenza iden',
    help_subtitle: 'Assistenza senza lasciare l’area di lavoro',
    open_help: 'Apri la pagina di assistenza completa',
    close_help: 'Chiudi assistenza',
    about: 'Informazioni e open source',
    open_navigation: 'Apri navigazione',
    close_navigation: 'Chiudi navigazione',
    development_enabled: 'Funzionalità di sviluppo abilitate',
    beta: 'Beta',
    impersonation: 'Impersonificazione',
    key: 'Chiave',
    value: 'Valore',
    error: 'Errore',
    details: 'Dettagli tecnici',
    callback_failed: 'Impossibile completare il ritorno dall’accesso.',
    back_sign_in: 'Torna all’accesso',
    powered_by: 'Realizzato con',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'Codice QR',
    sample_title: 'Vuoi vedere un esempio?',
    sample_description: 'Esplora un’applicazione di esempio che usa questa guida.',
    sample_action: 'Visualizza esempio',
    further_readings: 'Approfondimenti',
    complete_guide: 'Guida completa',
    custom_domains_notice: 'Dopo aver aggiunto <a>domini personalizzati</a>, puoi usare questo endpoint: <code>{{endpoint}}</code>.',
    my_project: 'Il mio progetto',
    my_secret: 'Il mio segreto',
    my_token: 'Il mio token',
    role_example: 'Lettore',
    reset_retry: 'Reimposta la configurazione e riprova',
    open_dev_panel: 'Apri pannello sviluppatore',
    close_dev_panel: 'Chiudi pannello sviluppatore',
    configuration: 'Configurazione',
    app_id: 'ID applicazione',
    extra_parameters: 'Parametri di accesso aggiuntivi',
    prompt: 'Richiesta di autenticazione',
    scope: 'Ambito',
    resource: 'Risorsa',
    resources_space_delimited: 'Risorse (separate da spazi)',
    sign_out_to_apply: 'Esci per applicare le modifiche.',
    refresh_token_grant: 'Autorizzazione tramite token di aggiornamento',
    organization_id: 'ID organizzazione',
    console_result: 'Consulta il risultato nella console del browser.',
    request_token: 'Richiedi token',
    user_info: 'Informazioni utente',
    get_id_token_claims: 'Ottieni dichiarazioni del token di identità',
    fetch_user_info: 'Recupera informazioni utente',
    device_initializing: 'Inizializzazione dell’autorizzazione del dispositivo…',
    device_success: 'Hai effettuato l’accesso all’applicazione demo.',
    sign_in_information: 'Le tue informazioni di accesso:',
    email: 'E-mail',
    username: 'Nome utente',
    user_id: 'ID utente',
    sign_out_demo: 'Esci dalla demo',
    device_expired: 'Codice dispositivo scaduto',
    generic_error: 'Si è verificato un errore',
    device_expired_description: 'Il codice del dispositivo è scaduto. Riprova per ottenerne uno nuovo.',
    sign_in_title: 'Accedi al tuo account',
    scan_instruction: 'Scansiona il codice QR o apri questo indirizzo su un altro dispositivo:',
    one_time_code: 'Inserisci il codice monouso',
    token_info: 'Informazioni sul token',
    get_access_token: 'Ottieni token di accesso',
    context_unavailable: 'Impossibile caricare le informazioni dell’account.',
    not_initialized: 'Le informazioni dell’account non sono inizializzate.',
    not_set: 'Non impostato',
    configured: 'Configurato',
    password: 'Password',
    phone: 'Numero di telefono',
    search_help: 'Cerca nell’assistenza',
    language: 'Lingua',
    menu: 'Menu',
    compatibility_notice: 'Compatibilità: i nomi ereditati di SDK, pacchetti, protocolli, componenti e intestazioni delle richieste Logto restano invariati.',
    source: 'Fonte',
    upstream_repository: 'Repository originale',
    current_fork: 'Repository attuale',
    license_notice: 'iden è basato su Logto, software open source con licenza Mozilla Public License 2.0.',
    about_description: 'Informazioni sul prodotto e attribuzioni open source.',
    page_not_found: 'Pagina non trovata',
    page_not_found_description: 'Questa pagina non è disponibile. Torna al centro assistenza per continuare.',
    introduction: 'Introduzione',
    quick_starts: 'Avvio rapido',
    integration: 'Integrazione',
    end_user_flows: 'Flussi utente finale',
    authorization: 'Autorizzazione',
    user_management: 'Gestione utenti',
    security: 'Sicurezza',
    customization: 'Personalizzazione',
    connectors: 'Connettori',
    organizations: 'Organizzazioni',
    self_hosting: 'Hosting autonomo',
    continue: 'Continua',
    loading: 'Caricamento…',
    save: 'Salva',
    saved: 'Salvato',
    try_again: 'Riprova',
    client_id: 'ID client',
    client_secret: 'Segreto client',
    redirect_uri: 'URI di reindirizzamento',
    status: 'Stato',
    type: 'Tipo',
    permissions: 'Permessi',
    token_data: 'Dati del token',
    context_data: 'Dati di contesto',
    jwt_extra_claims: 'Dichiarazioni aggiuntive del token',
    action_result: 'Risultato dell’azione',
    social_account_already_linked: 'Questo account social è già collegato.',
};
export default Object.freeze(interfacePhrases);
